<template>
  <v-container fluid class="mt-5">
    <v-row justify="start">
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Ricerca i prodotti da aggiungere
          </v-card-title>
          <v-card-subtitle>
            Sono possibili anche aggiunte multiple.
          </v-card-subtitle>
          <v-card-text>
            <v-data-table
              v-model="selected"
              :show-select="totaleArticoli > 0"
              item-key="_id"
              :headers="headers"
              :items="articoliSorted"
              :options.sync="options"
              :server-items-length="totaleArticoli"
              :loading="loading"
              class="elevation-1"
              :footer-props="{
                itemsPerPageOptions: [5, 10, 15, 50, 100]
              }"
              dense
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Articoli</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <filtri :usaTagliaColore="usaTagliaColore" @ricerca="onRicerca"/>
              </template>
              <template v-slot:[`item.prezzo.L1.base`]="{ item }">
                {{ item.prezzo && item.prezzo.L1 && item.prezzo.L1.base | dueDecimali }}
              </template>
              <template v-slot:[`item.magazzino.giacenza`]="{ item }">
                <span :title="giacenzaTotale(item)">{{ calcolaGiacenza(item) | dueDecimali }}</span>
              </template>
              <template v-slot:no-data>
                <h3>Cerca gli articoli da aggiungere all'offerta</h3>
              </template>
              <template v-slot:[`body.append`] v-if="selected.length > 0">
                <td :colspan="4" v-if="usaTagliaColore">
                  <v-btn class="text-right mr-5 mt-5 mb-2" @click="addProdottoId">Aggiungi i prodotti per id</v-btn>
                  <v-btn class="text-right  mt-5 mb-2" @click="addProdottoCode" color="blue-grey lighten-4">Aggiungi i prodotti per codice</v-btn>
                </td>
                <td :colspan="4" v-else>
                  <v-btn class="text-right mr-5 mt-5 mb-2" @click="addProdottoId">Aggiungi i prodotti</v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Prodotti in offerta
          </v-card-title>
          <v-card-subtitle>
            Prezzo o sconti sono in alternativa. Se non valorizzati, vengono considerati i valori di default della scheda dati generali
          </v-card-subtitle>
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Id</th>
                    <th class="text-left">Codice</th>
                    <th class="text-left">Descrizione</th>
                    <th class="text-right">Prezzo L1</th>
                    <th class="text-right">Prezzo</th>
                    <th class="text-right">Sconto %</th>
                    <th class="text-right">Sconto €</th>
                  </tr>
                </thead>                
                <tbody>
                  <tr v-for="(v, index) in dati.articoli" :key="index" dense>
                    <!-- <td width="15%"><v-text-field v-model="v.id" :readonly="true"/></td> -->
                    <td width="15%">{{ v.id }}</td>
                    <!-- <td width="15%"><v-text-field v-model="v.codice" :readonly="true" /></td> -->
                    <td width="15%">{{ v.codice }}</td>
                    <!-- <td><v-text-field v-model="v.descrizione" :readonly="true"/></td> -->
                    <td>{{ v.descrizione }}</td>
                    <!-- <td width="10%"><v-text-field v-model="v.prezzoL1" reverse :readonly="true" /></td> -->
                    <td width="10%" class="text-right">{{ v.prezzoL1 }}</td>
                    <td width="10%"><v-text-field v-model="v.prezzo" reverse :rules="[rules.numero]" clearable hide-details/></td>
                    <td width="5%"><v-text-field v-model="v.scontoPercentuale" reverse :rules="[rules.numero]" clearable hide-details/></td>
                    <td width="5%"><v-text-field v-model="v.scontoEuro" reverse :rules="[rules.numero]" clearable hide-details/></td>
                    <td width="3%"><v-btn icon @click="deleteItem(v)" small><v-icon>mdi-delete-outline</v-icon></v-btn></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-switch v-model="confermaCancellazione" dense inset label="Conferma cancellazione"></v-switch>
          </v-card-text>
        </v-card>
      </v-col>      
    </v-row>
    <v-btn v-if="!readOnly" class="mt-5" @click="salvaModifiche">Salva modifiche</v-btn>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Confermi cancellazione ?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Annulla</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>    
  </v-container>
</template>

<script>
  import _ from 'lodash'
  import { validazioni } from '@/mixins/validazioni.js'
  import configurazioni from '@/services/configurazioniService.js'
  import prodotti from '@/services/prodottiService.js'
  import Filtri from '@/views/articoli/filtri'

  export default {
    props: {
      dati: Object,
      readOnly: { type: Boolean, default: false }
    },
    components: {
      Filtri
    },
    mixins: [
      validazioni
    ],    
    data: (vm) => ({
      menuStart: false,
      menuEnd: false,
      modal: false,
      loading: false,
      orari: [],
      editedIndex: -1,
      editedItem: null,
      dialogDelete: false,
      usaTagliaColore: false,
      articoli: [],
      selected: [],
      totaleArticoli: 0,
      options: { itemsPerPage: 50 },
      headersBase: [
        { text: 'Codice', value: 'codice', align: 'start' },
        { text: 'Descrizione', value: 'descrizione' }
      ],
      headersTC: [
        { text: 'Taglia', value: 'varianti.variante1.descrizione' },
        { text: 'Colore', value: 'varianti.variante2.descrizione' }
      ],
      headersTail: [
        { text: 'Marchio', value: 'marchio' },
        { text: 'Prezzo €', name: 'prezzo', value: 'prezzo.L1.base', align: 'end' },
        { text: 'Giacenza', value: 'magazzino.giacenza', align: 'end' }
      ],
      confermaCancellazione: true
    }),
    async created() {
      const backoffice = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      this.usaTagliaColore = backoffice.usaTagliaColore || false
    },
    async mounted() {
    },
    computed: {
      articoliSorted() {
        const els = this.articoli
        if (this.options.sortBy && this.options.sortBy.length > 0) {
          return els
        } else {
          const elSorted = _.sortBy(els, ['descrizione', 'varianti.variante2.descrizione', 'varianti.variante1.descrizione'])
          return elSorted
        }
      },
      headers() {
        let base = this.headersBase
        if (this.usaTagliaColore) {
          base = base.concat(this.headersTC)
        }
        return base.concat(this.headersTail)
      },
      magazziniMultipli() {
        return this.$store.getters['magazzini/magazziniMultipli']
      },
      magazzinoSelezionato() {
        // Si può usare il getter perchè la chiamata asincrona è stata fatta dalla root
        return this.$store.getters['magazzini/codiceMagazzino']
      }      
    },
    methods: {
      deleteItem (item) {
        if (this.confermaCancellazione) {
          this.editedIndex = this.dati.articoli.indexOf(item)
          this.editedItem = Object.assign({}, item)
          this.dialogDelete = true
        } else {
          this.dati.articoli.splice(this.editedIndex, 1)
        }
      },
      deleteItemConfirm () {
        this.dati.articoli.splice(this.editedIndex, 1)
        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = null
          this.editedIndex = -1
        })
      },
      async onRicerca(filtri) {
        this.filtri = filtri
        this.filtri.tipoItem = 'PRODOTTO'
        await this.getDataFromApi()
      },
      async getDataFromApi () {
        try {
          this.loading = true
          const data = await prodotti.getFilteredProducts(this.filtri, this.options)
          this.articoli = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []

          this.totaleArticoli = data.total_rows
        } catch(err) {
          this.articoli = []
          this.totaleArticoli = 0
        } finally {
          this.loading = false
        }
      },
      calcolaGiacenza(item) {
        const giacenza = _.get(item, 'magazzino.giacenza', 0)
        if (!this.magazziniMultipli) {
          return giacenza
        } else {
          const giacenzaParziale = _.get(item, 'magazzino.giacenzaParziale', 0)
          if (typeof giacenzaParziale === 'object' && !_.isEmpty(giacenzaParziale)) {
            const gg = giacenzaParziale[this.magazzinoSelezionato] || {}
            return gg.giacenza || 0
          } else {
            return this.magazzinoSelezionato === 'mag01' ? giacenza : 0
          }
        }
      },
      giacenzaTotale(item) {
        return `Giacenza totale: ${item.magazzino.giacenza || 0}`
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      },
      addProdottoId() {
        for (let p of this.selected) {
          // Quando salva, togliere descrizione e prezzoL1 --> ricalcolare su popola
          if (!this.dati.articoli.find(x => x.id === p._id)) {
            const descrizione = this.usaTagliaColore ? `${p.descrizione} ${_.get(p, 'varianti.variante2.descrizione', '')} ${_.get(p, 'varianti.variante1.descrizione', '')}`.trim() : p.descrizione
            const articolo = {
              id: p._id,
              codice: '',
              descrizione: descrizione,
              prezzoL1: _.get(p, 'prezzo.L1.base', ''),
              prezzo: '',
              scontoPercentuale: '',
              scontoEuro: ''
            }
            this.dati.articoli.push(articolo)
          }
        }
        this.annullaSelezione()
      },
      addProdottoCode() {
        for (let p of this.selected) {
          // Quando salva, togliere descrizione e prezzoL1 --> ricalcolare su popola
          if (!this.dati.articoli.find(x => x.codice === p.codice)) { 
            const articolo = {
              id: '',
              codice: p.codice,
              descrizione: p.descrizione,
              prezzoL1: _.get(p, 'prezzo.L1.base', ''),
              prezzo: '',
              scontoPercentuale: '',
              scontoEuro: ''
            }
            this.dati.articoli.push(articolo)
          }
        }
        this.annullaSelezione()
      },
      salvaModifiche() {
        this.$emit('salva', this.dati)
      }      
    }
  }
</script>
